/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Missing_BodyInputs */

const en_recipe_missing_body = /** @type {(inputs: Recipe_Missing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It may have been deleted.`)
};

const de_recipe_missing_body = /** @type {(inputs: Recipe_Missing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurde vielleicht gelöscht.`)
};

/**
* | output |
* | --- |
* | "It may have been deleted." |
*
* @param {Recipe_Missing_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_missing_body = /** @type {((inputs?: Recipe_Missing_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Missing_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_missing_body(inputs)
	return en_recipe_missing_body(inputs)
});